import { post } from "../helpers/admin_api_helper"

export const deleteFile = (data: {}) => post(`/delete`, data)